import PropTypes from "prop-types";
import { filter } from "lodash";
import Checkbox from "@shared/v2/Checkbox";
import Dropdown from "@shared/v2/Dropdown";
import UserListing from "./UserListing";

const UserOption = ({
  componentProps: {
    data: { label, value },
    selectProps: { selectedValues, onSelect, isMultiSelect },
  },
}) => {
  // flag if the option is selected from the user array
  const isSelected = filter(selectedValues, (u) => u.uuid === value.uuid).length > 0;
  return (
    <button
      type="button"
      className="tw-flex tw-items-center tw-gap-[8px] tw-w-full tw-border-none tw-bg-white hover:tw-bg-gray-5"
      onClick={(e) => {
        e.preventDefault();
        onSelect(value);
      }}
    >
      {isMultiSelect && <Checkbox checked={isSelected} />}
      <UserListing name={label} imageUrl={value.image_url} />
    </button>
  );
};

UserOption.propTypes = {
  componentProps: PropTypes.shape({
    data: PropTypes.shape().isRequired,
    selectProps: PropTypes.shape().isRequired,
  }).isRequired,
};

const UserSelect = ({
  options = [],
  value = null,
  isLoading = false,
  isMultiSelect = false,
  onSelect,
  "data-cy": dataCy,
}) => (
  <div data-cy={dataCy} className="tw-relative">
    <Dropdown
      value={null}
      options={options}
      isLoading={isLoading}
      isClearable={false}
      isSearchable
      isMultiSelect={isMultiSelect}
      placeholder="Search or select users"
      components={{ Option: UserOption }}
      selectedValues={value}
      onSelect={onSelect}
      menuShouldComeToFront
    />
  </div>
);

UserSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  value: PropTypes.arrayOf(PropTypes.shape()),
  isLoading: PropTypes.bool,
  isMultiSelect: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  "data-cy": PropTypes.string,
};

UserSelect.defaultProps = {
  value: null,
  isLoading: false,
  isMultiSelect: false,
  "data-cy": "user-select",
};

export default UserSelect;
